class ProductRecommendations extends HTMLElement {
  preservedHeight = null;

  constructor() {
    super();
  }

  connectedCallback() {
    this.preserveHeight();

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", () => {
        this.loadRecommendations(this.dataset.productId);
      });
    } else {
      this.loadRecommendations(this.dataset.productId);
    }
  }

  preserveHeight() {
    // Calculate and preserve height to prevent layout shift
    const currentHeight = this.offsetHeight;

    // If element already has content, use its height
    if (currentHeight > 0) {
      this.preservedHeight = currentHeight;
      this.style.minHeight = `${currentHeight}px`;
      return;
    }

    // Estimate height based on typical recommendation section
    // Heading (~60px) + Product cards (~400-500px) + margins
    const estimatedHeight = window.innerWidth <= 999 ? 350 : 500;
    this.preservedHeight = estimatedHeight;
    this.style.minHeight = `${estimatedHeight}px`;
  }

  removeHeightPreservation() {
    if (this.preservedHeight) {
      // Use requestAnimationFrame to ensure content is rendered before removing height
      requestAnimationFrame(() => {
        this.style.minHeight = "";
        this.preservedHeight = null;
      });
    }
  }

  loadRecommendations(productId) {
    fetch(
      `${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`
    )
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement("div");
        html.innerHTML = text;
        const recommendations = html.querySelector("product-recommendations");

        if (recommendations?.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
          // Remove height preservation once content is loaded
          this.removeHeightPreservation();
        } else {
          // No content loaded, remove height preservation and element if needed
          this.removeHeightPreservation();
        }

        if (
          !this.querySelector("slideshow-component") &&
          this.classList.contains("complementary-products")
        ) {
          this.remove();
          return;
        }

        if (html.querySelector(".grid__item")) {
          this.classList.add("product-recommendations--loaded");
        }
      })
      .catch((e) => {
        console.error(e);
        // Remove height preservation on error
        this.removeHeightPreservation();
      })
      .finally(() => {
        document
          .querySelectorAll("[data-wishlist-toggle]")
          .forEach((button) => {
            const wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];
            const productHandle = button.dataset.productHandle;
            if (wishlist.includes(productHandle)) {
              button.classList.add("in-wishlist", "remove");
              button.setAttribute("aria-label", "remove to wishlist");
            }
          });

        const allCards = document.querySelectorAll(".card-product");

        allCards.forEach((product) => {
          const slider = product.querySelector(".card__slider-container");

          product.addEventListener("click", (e) => {
            // Handle color swatches
            const colorOption = e.target.closest(
              ".card-product__color-option:not(.disabled)"
            );
            // Color Swatches Function
            if (colorOption) {
              e.preventDefault();
              handleColorSwatch(colorOption, product);
            }
          });
        });
      });
  }
}

customElements.define("product-recommendations", ProductRecommendations);
